import React, {useState, useEffect, useRef} from 'react';
import axios from 'axios';
import '../config.js';

import { theme, getInputFormattedDateFromString } from '../services/helper.js';
import { alertService } from '../services/alert.service.js';
import RefundListItem from '../components/refundListItem.js';
import Progress from '../components/progress.js';
import { Paginator } from '../components/paginator.js';
import SearchClient from '../components/searchClient.js';
import Sort from '../components/sort.js';
import SearchInvoice from '../components/searchInvoice.js';
let searchData = {};

function Refunds() {
  const [search, setSearch] = useState('');
  const [sortBy, setSortBy] = useState('refund.updation_date');
  const [sortOrder, setSortOrder] = useState(false);
  const [dateSearch, setDateSearch] = useState('none');
  const [refunds, setRefunds] = useState([]);
  const [page, setPage] = useState(0);
  const [loading, setLoading] = useState(true);
  const [description, setDescription] = useState(null);
  const [amount, setAmount] = useState(0);
  const [currency, setCurrency] = useState('INR');
  const [notifySms, setNotifySms] = useState(0);
  const [notifyMail, setNotifyMail] = useState(0);
  const [total, setTotal] = useState(0);
  const [filterTotal, setFilterTotal] = useState(0);
  const [client, setClient] = useState(null);
  const [invoice, setInvoice] = useState(null);
  const [cancellation, setCancellation] = useState(0);
  const [transactionId, setTransactionId] = useState(null);
  const [createdDate, setCreatedDate] = useState(getInputFormattedDateFromString(Date.now()));
  const [bank, setBank] = useState(null);
  const [bank_account, setBankAccount] = useState(null);
  const [account_holder_name, setAccountHolderName] = useState(null);
  const [ifsc_code, setIfsc] = useState(null);

  const handleSubmit = (event) =>{
    event.preventDefault();
    if(amount && parseInt(amount) > 0 && description && client && invoice && parseInt(amount) <= parseInt(invoice.paid) && bank && bank_account && account_holder_name && ifsc_code && transactionId){
      const formData = new FormData;
      formData.append('description', description);
      formData.append('task', "create");
      formData.append('client', client.client_id);
      formData.append('invoice', invoice.invoice_id);
      formData.append('createdDate', createdDate);
      formData.append('amount', amount);
      formData.append('currency', currency);
      formData.append('cancellation', cancellation);
      formData.append('bank', bank);
      formData.append('bank_account', bank_account);
      formData.append('account_holder_name', account_holder_name);
      formData.append('ifsc_code', ifsc_code);
      formData.append('transactionId', transactionId);
      formData.append('notifySms', notifySms);
      formData.append('notifyMail', notifyMail);
      formData.append('token', localStorage.getItem("token"));
      setLoading(true);
      axios.post(global.config.api_server+'refund',formData).then(res => {
        if(res.status === 200 && res.data.status === "success"){
          alertService.success('Refund Receipt Created');
          setTimeout(function(){
            window.location.reload();
          }, 1000);
        }else{
          alertService.error(res.data.error);
          setLoading(false);
        }
      }).catch(err => {
        alertService.error(err);
        setLoading(false);
      });
    }else{
      alertService.error('Fields must have valid values');
      setLoading(false);
    }
  }

  const handleNotifySms = (event) =>{
    if(event.target.checked){
      setNotifySms(1);
    }else{
      setNotifySms(0);
    }
  }

  const handleNotifyMail = (event) =>{
    if(event.target.checked){
      setNotifyMail(1);
    }else{
      setNotifyMail(0);
    }
  }

  const fetchRefunds = (pSortBy, pSortOrder, pPage, pSearch, pSearchType) => {
    let dateQ = "";
    if(pSearchType === 'range'){
      dateQ = "refund.updation_date>"+searchData.dateSearchFrom+",refund.updation_date<"+searchData.dateSearchTo;
    }else if (pSearchType === 'monthYear'){
      if(searchData.dateSearchMonth > 0 && searchData.dateSearchYear > 0){
        dateQ = "MONTH(refund.updation_date);"+searchData.dateSearchMonth+",YEAR(refund.updation_date);"+searchData.dateSearchYear;
      }else if(searchData.dateSearchMonth > 0){
        dateQ = "MONTH(refund.updation_date);"+searchData.dateSearchMonth;
      }else if(searchData.dateSearchYear > 0){
        dateQ = "YEAR(refund.updation_date);"+searchData.dateSearchYear;
      }
    }
    let q = "";
    if(pSearch & dateQ != ''){
      q = "q="+pSearch+","+dateQ+"&";
    }else if (pSearch){
      q = "q="+pSearch+"&";
    }else if (dateQ != ''){
      q = "q="+dateQ+"&";
    }
    let order = 'desc';
    if(pSortOrder){
      order = 'asc';
    }
    let uri = global.config.api_server+'refunds?limit='+global.config.items_per_page+'&page='+pPage+'&orderBy='+pSortBy+'&order='+order+'&'+q+'token='+localStorage.getItem("token");
    axios.get(uri)
    .then(res => {
      if(res.status === 200 && res.data.status === "success"){
        setRefunds(res.data.refunds);
        setTotal(res.data.total);
        setFilterTotal(res.data.filterTotal);
        setLoading(false);
      }
    }).catch(err => {
      alertService.error(err);
    });
  }

  const checkHandleSearch = (e) => {
    if (e.key === 'Enter') {
      handleSearch(e);
    }
  }

  const handleSearch = (event) => {
    fetchRefunds(sortBy, sortOrder, 0, search, dateSearch);
  }

  const handleSearchInput = (event) => {
    const target = event.target;
    const value = target.value;
    const name = target.name;
    searchData[name] = value;
  }

  const updateSortParam = (e, field) => {
    let newSearchOrder = true;
    if(field === sortBy){
      newSearchOrder = !sortOrder;
    }else{
      setSortBy(field);
    }
    setSortOrder(newSearchOrder);
    fetchRefunds(field, newSearchOrder, 0, search, dateSearch);
  }
  
  const resetSearch = (event) => {
    setSearch('');
    setDateSearch("none");
    searchData = {};
    fetchRefunds(sortBy, sortOrder, 0, null, 'none');
  }

  const updateClient = (c) => {
    setClient(c);
    setBank(c.bank);
    setBankAccount(c.bank_account);
    setAccountHolderName(c.account_holder_name);
    setIfsc(c.ifsc_code);
  }
  
  useEffect(()=>{
    fetchRefunds(sortBy, sortOrder, 0, search, dateSearch);
  }, []);
  
  const onPageChange = (index_start) => {
    let lPage = index_start / global.config.items_per_page;
    setPage(lPage);
    fetchRefunds(sortBy, sortOrder, lPage, search, dateSearch);
  }

  let balance = 0;
  if(invoice && amount){
    balance = (parseFloat(invoice.amount) - (parseFloat(invoice.paid) + parseFloat(amount)));
  }else if (invoice){
    balance = (parseFloat(invoice.amount) - parseFloat(invoice.paid));
  }

  return(
    <div className="container-fluid">
      {loading === true ? (
        <Progress label='Loading..'/>
      ):
      <div>
        <div className="card shadow mb-4">
          <div className="card-header py-3">
            <a href="#" className={'btn btn-icon-split float-right btn-'+theme()} data-toggle="modal" data-target="#createNewRefundModal">
              <span className="icon text-white-50">
                <i className="fas fa-file"></i>
              </span>
              <span className="text">Create Refund Receipt</span>
            </a>
            <h6 className={'form-group mr-3 font-weight-bold text-'+theme()}>Refund Receipts</h6>
            <div class="search-container">
              <div className="form-group mr-3">
                <input name="search" className="form-control" placeholder="Search" value={search} onKeyDown={(e) => checkHandleSearch(e)} onChange={(e) => setSearch(e.target.value)}/>
              </div>
              <div className={"form-group mr-3"}>
                <select name="dateSearch" className="form-control" value={dateSearch} id="dateSearch" onChange={(e) => setDateSearch(e.target.value)}>
                  <option value="none">Search By Date</option>
                  <option value="range">Range</option>
                  <option value="monthYear">Month-Year</option>
                </select>
              </div>
              {dateSearch === 'range' && 
                <div className="form-group mr-3">
                  <input type="date" name="dateSearchFrom" className="form-control" placeholder="From" onChange={(e)=>handleSearchInput(e)}/>
                </div>
              }
              {dateSearch === 'range' && 
                <div className="form-group mr-3">
                  <input type="date" name="dateSearchTo" className="form-control" placeholder="To" onChange={(e)=>handleSearchInput(e)}/>
                </div>
              }
              {dateSearch === 'monthYear' && 
                <div className="form-group mr-3">
                  <select name="dateSearchMonth" className="form-control" id="dateSearchMonth" onChange={(e)=>handleSearchInput(e)}>
                    {global.config.months.map(d =>
                        <option value={d.value} key={d.value}>{d.name}</option>
                    )}
                  </select>
                </div>
              }
              {dateSearch === 'monthYear' && 
                <div className="form-group mr-3">
                  <select name="dateSearchYear" className="form-control" id="dateSearchYear" onChange={(e)=>handleSearchInput(e)}>
                    <option value="0">None</option>
                    {global.config.years.split(",").map(d =>
                        <option value={d} key={d}>{d}</option>
                    )}
                  </select>
                </div>
              }
              <div className="form-group mr-3">
                <a href="#" className="btn btn-primary btn-icon-split" onClick={handleSearch}>
                  <span className="icon">
                    <i className="fas fa-search"></i>
                  </span>
                </a>
              </div>
              {(search || dateSearch != 'none' ) &&
                <div className="form-group mr-3">
                  <a href="#" className="btn btn-default btn-icon-split" onClick={resetSearch}>
                    <span className="icon">
                      <i className="fas fa-times"></i>
                    </span>
                  </a>
                </div>
              }
            </div>
          </div>
          <div className="card-body">
            <div className="table-responsive">
              <div className="row">
                <div className="col-sm-12">
                  <table className="table table-bordered" width="100%">
                    <thead>
                      <tr>
                        <th onClick={(e) => updateSortParam(e,'refund_id')}>Refund Receipt Id <Sort field="refund_id" sortBy={sortBy} sortOrder={sortOrder}/></th>
                        <th onClick={(e) => updateSortParam(e,'client.first_name')}>Client <Sort field="client.first_name" sortBy={sortBy} sortOrder={sortOrder}/></th>
                        <th>Additional Note</th>
                        <th onClick={(e) => updateSortParam(e,'amount')}>Amount <Sort field="amount" sortBy={sortBy} sortOrder={sortOrder}/></th>
                        <th onClick={(e) => updateSortParam(e,'currency')}>Currency <Sort field="currency" sortBy={sortBy} sortOrder={sortOrder}/></th>
                        <th onClick={(e) => updateSortParam(e,'updation_date')}>Updated On <Sort field="updation_date" sortBy={sortBy} sortOrder={sortOrder}/></th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {refunds.map(refund=>
                        <RefundListItem key={refund.refund_id} info={refund} type="all"/>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
              <Paginator
                itemCount={filterTotal}
                itemsPerPage={global.config.items_per_page}
                showNextPages={2}
                showPrevPages={2}
                filterTotal={filterTotal}
                grandTotal={total}
                onClick={onPageChange.bind(this)}
              />
            </div>
          </div>
        </div>
        <div className="modal fade" id="createNewRefundModal" tabIndex="-1" role="dialog" aria-labelledby="create-popup" aria-hidden="true">
          <div className="modal-dialog modal-xl" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" id="create-popup">Create Refund Receipt</h5>
                <button className="close" type="button" data-dismiss="modal" aria-label="Close">
                  <span aria-hidden="true">×</span>
                </button>
              </div>
              <form>
                <div className="modal-body">
                  <SearchClient handleSubmit={(e) => {updateClient(e); setInvoice(null);}}></SearchClient>
                  {client && 
                    <SearchInvoice handleSubmit={(e) => { setInvoice(e); setCurrency(e.currency);}} client={client.client_id}></SearchInvoice>
                  }
                  {invoice && 
                    <div>
                      <div class="row">
                        <div class="col-md-6">
                          <div className="form-group">
                            <label>Total Refund Amount (Less than or equal to: {invoice.paid}) *</label>
                            <input type="number" value={amount} maxLength="50" name="amount" className="form-control" id="amount" placeholder="Enter Total Refund Amount" onChange={(e) => setAmount(e.target.value)}/>
                          </div>
                          <div className="form-group">
                            <label>Transaction Id *</label>
                            <input type="text" value={transactionId} maxLength="50" name="transactionId" className="form-control" id="transactionId" placeholder="Enter Transaction  Id" onChange={(e) => setTransactionId(e.target.value)}/>
                          </div>
                        </div>
                        <div class="col-md-6">
                          <div className="form-group">
                            <label>Currency*</label>
                            <select name="type" className="form-control" id="type" value={currency} onChange={(e) => setCurrency(e.target.value)}>
                              {global.config.currencies.split(",").map(d =>
                                  <option value={d} key={d}>{d}</option>
                              )}
                            </select>
                          </div>
                          <div className="form-group">
                            <label>Cancellation Charges *</label>
                            <input type="number" value={cancellation} maxLength="50" name="cancellation" className="form-control" id="cancellation" placeholder="Enter Cancellation Charges" onChange={(e) => setCancellation(e.target.value)}/>
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-md-6">
                          <div className="form-group">
                            <label>Bank *</label>
                            <input type="text" value={bank} maxLength="50" name="bank" className="form-control" id="bank" placeholder="Enter Bank Name" onChange={(e) => setBank(e.target.value)}/>
                          </div>
                          <div className="form-group">
                            <label>Account Number *</label>
                            <input type="text" value={bank_account} maxLength="50" name="bank_account" className="form-control" id="bank_account" placeholder="Enter Account Number" onChange={(e) => setBankAccount(e.target.value)}/>
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="form-group">
                            <label>Account Holder Name *</label>
                            <input type="text" value={account_holder_name} maxLength="50" name="account_holder_name" className="form-control" id="account_holder_name" placeholder="Enter Account Holder Name" onChange={(e) => setAccountHolderName(e.target.value)}/>
                          </div>
                          <div className="form-group">
                            <label>IFSC Code *</label>
                            <input type="text" value={ifsc_code} maxLength="15" name="ifsc_code" className="form-control" id="ifsc_code" placeholder="Enter IFSC Code" onChange={(e) => setIfsc(e.target.value)}/>
                          </div>
                        </div>
                      </div>
                      <div className="form-group">
                        <label>Additional Note *</label>
                        <textarea maxLength="400" name="description" className="form-control textarea" id="description" placeholder="Additional Note" onChange={(e) => setDescription(e.target.value)}></textarea>
                      </div>
                      <div className="form-group">
                        <label>Created Date</label>
                        <input type="date" value={createdDate} maxLength="50" name="createdDate" className="form-control" id="createdDate" placeholder="Enter Created Date" onChange={(e) => setCreatedDate(e.target.value)}/>
                      </div>
                      <div className="form-group">
                        <input type="checkbox" onChange={(e) => handleNotifyMail(e)}/> Send Mail &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<input type="checkbox" onChange={(e) => handleNotifySms(e)}/> Send SMS
                      </div>
                    </div>
                  }
                  {loading === true ? (
                    <Progress label='Creating..' small={true}/>
                  ):null}
                </div>
                <div className="modal-footer">
                  <button className="btn btn-default" type="reset" data-dismiss="modal">Close</button>
                  <button className={'btn btn-'+theme()} type="button" onClick={handleSubmit}>Submit</button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    }
    </div>
  )
}

export default Refunds;